var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("article", { staticClass: "dashboard" }, [
    _c(
      "section",
      { staticClass: "search-section" },
      [
        _c(
          "el-form",
          { attrs: { model: _vm.searchForm, inline: "" } },
          [
            _c(
              "el-form-item",
              [
                _c(
                  "el-radio-group",
                  {
                    on: { change: _vm.handleTypeChange },
                    model: {
                      value: _vm.searchForm.type,
                      callback: function($$v) {
                        _vm.$set(_vm.searchForm, "type", $$v)
                      },
                      expression: "searchForm.type"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: "1" } }, [
                      _vm._v(_vm._s(_vm.$t("日期")))
                    ]),
                    _c("el-radio", { attrs: { label: "2" } }, [
                      _vm._v(_vm._s(_vm.$t("月份")))
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-form-item",
              [
                _c("el-date-picker", {
                  attrs: {
                    type: _vm.searchForm.type === "1" ? "date" : "month",
                    placeholder:
                      _vm.searchForm.type === "1"
                        ? _vm.$t("选择日期")
                        : _vm.$t("选择月份"),
                    format:
                      _vm.searchForm.type === "1" ? "yyyy-MM-dd" : "yyyy-MM",
                    "value-format":
                      _vm.searchForm.type === "1" ? "yyyy-MM-dd" : "yyyy-MM"
                  },
                  on: { change: _vm.handleDateChange },
                  model: {
                    value: _vm.searchForm.date,
                    callback: function($$v) {
                      _vm.$set(_vm.searchForm, "date", $$v)
                    },
                    expression: "searchForm.date"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c("section", { staticClass: "basic-data" }, [
      _c("div", { staticClass: "data-card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("span", { staticClass: "card-icon revenue" }, [_vm._v("$")]),
          _c("span", { staticClass: "card-title" }, [
            _vm._v(_vm._s(_vm.$t("集团营收")))
          ])
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("span", { staticClass: "card-value" }, [
            _vm._v(_vm._s(_vm.formatNumber(_vm.basicData.totalRevenue)))
          ])
        ])
      ]),
      _c("div", { staticClass: "data-card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("span", { staticClass: "card-icon rate" }, [_vm._v("%")]),
          _c("span", { staticClass: "card-title" }, [
            _vm._v(_vm._s(_vm.$t("集团出租率")))
          ])
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("span", { staticClass: "card-value" }, [
            _vm._v(_vm._s(_vm.basicData.avgOccupancyRate) + "%")
          ])
        ])
      ]),
      _c("div", { staticClass: "data-card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("span", { staticClass: "card-icon adr" }, [_vm._v("⌂")]),
          _c("span", { staticClass: "card-title" }, [
            _vm._v(_vm._s(_vm.$t("集团ADR")))
          ])
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("span", { staticClass: "card-value" }, [
            _vm._v(_vm._s(_vm.basicData.avgADR))
          ])
        ])
      ]),
      _c("div", { staticClass: "data-card" }, [
        _c("div", { staticClass: "card-header" }, [
          _c("span", { staticClass: "card-icon revpar" }, [_vm._v("¤")]),
          _c("span", { staticClass: "card-title" }, [
            _vm._v(_vm._s(_vm.$t("集团RevPAR")))
          ])
        ]),
        _c("div", { staticClass: "card-body" }, [
          _c("span", { staticClass: "card-value" }, [
            _vm._v(_vm._s(_vm.basicData.revPAR))
          ])
        ])
      ])
    ]),
    _c("section", { staticClass: "content-section" }, [
      _c("div", { staticClass: "trend-section" }, [
        _c(
          "div",
          { staticClass: "section-header" },
          [
            _c("span", { staticClass: "section-title" }, [
              _vm._v(_vm._s(_vm.$t("数据趋势")))
            ]),
            _c(
              "el-tabs",
              {
                staticClass: "trend-tabs",
                attrs: { type: "card" },
                model: {
                  value: _vm.activeTab,
                  callback: function($$v) {
                    _vm.activeTab = $$v
                  },
                  expression: "activeTab"
                }
              },
              [
                _c("el-tab-pane", {
                  attrs: { label: _vm.$t("集团营收"), name: "revenue" }
                }),
                _c("el-tab-pane", {
                  attrs: { label: _vm.$t("集团出租率"), name: "occupancy" }
                }),
                _c("el-tab-pane", {
                  attrs: { label: _vm.$t("集团ADR"), name: "adr" }
                }),
                _c("el-tab-pane", {
                  attrs: { label: _vm.$t("集团RevPAR"), name: "revpar" }
                })
              ],
              1
            )
          ],
          1
        ),
        _c("div", { staticClass: "chart-container" }, [
          _c(
            "svg",
            {
              staticClass: "trend-chart",
              attrs: { viewBox: `0 0 ${_vm.chartWidth} ${_vm.chartHeight}` }
            },
            [
              _c(
                "g",
                { staticClass: "grid-lines" },
                [
                  _vm._l(5, function(i) {
                    return _c("line", {
                      key: "h" + i,
                      attrs: {
                        x1: _vm.padding,
                        y1: _vm.padding + (_vm.chartInnerHeight / 4) * (i - 1),
                        x2: _vm.chartWidth - _vm.padding,
                        y2: _vm.padding + (_vm.chartInnerHeight / 4) * (i - 1),
                        stroke: "#DEE3EE",
                        "stroke-dasharray": "4,4"
                      }
                    })
                  }),
                  _vm._l(_vm.xLabels, function(label, i) {
                    return _c("line", {
                      key: "v" + i,
                      attrs: {
                        x1:
                          _vm.padding +
                          (_vm.chartInnerWidth /
                            (_vm.xLabels.length - 1 || 1)) *
                            i,
                        y1: _vm.padding,
                        x2:
                          _vm.padding +
                          (_vm.chartInnerWidth /
                            (_vm.xLabels.length - 1 || 1)) *
                            i,
                        y2: _vm.chartHeight - _vm.padding,
                        stroke: "#DEE3EE",
                        "stroke-dasharray": "4,4"
                      }
                    })
                  })
                ],
                2
              ),
              _c(
                "g",
                { staticClass: "y-labels" },
                _vm._l(_vm.yLabels, function(label, i) {
                  return _c(
                    "text",
                    {
                      key: "yl" + i,
                      staticClass: "axis-label",
                      attrs: {
                        x: _vm.padding - 10,
                        y: _vm.padding + (_vm.chartInnerHeight / 4) * i + 4,
                        "text-anchor": "end"
                      }
                    },
                    [_vm._v(_vm._s(label))]
                  )
                }),
                0
              ),
              _c(
                "g",
                { staticClass: "x-labels" },
                _vm._l(_vm.xLabels, function(label, i) {
                  return _c(
                    "text",
                    {
                      key: "xl" + i,
                      staticClass: "axis-label",
                      style: {
                        display: _vm.shouldShowXLabel(i) ? "block" : "none"
                      },
                      attrs: {
                        x:
                          _vm.padding +
                          (_vm.chartInnerWidth /
                            (_vm.xLabels.length - 1 || 1)) *
                            i,
                        y: _vm.chartHeight - 10,
                        "text-anchor": "middle"
                      }
                    },
                    [_vm._v(_vm._s(label))]
                  )
                }),
                0
              ),
              _c("path", {
                staticClass: "chart-line",
                attrs: {
                  d: _vm.currentChartPath,
                  fill: "none",
                  stroke: _vm.currentChartColor,
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                }
              }),
              _vm._l(_vm.chartPoints, function(point, index) {
                return _c("g", { key: "point" + index }, [
                  _c("circle", {
                    staticClass: "data-point",
                    attrs: {
                      cx: point.x,
                      cy: point.y,
                      r: "3",
                      fill: _vm.currentChartColor
                    },
                    on: {
                      mouseenter: function($event) {
                        return _vm.showTooltip($event, point, index)
                      },
                      mouseleave: _vm.hideTooltip
                    }
                  }),
                  _c("circle", {
                    staticClass: "data-point-hover",
                    attrs: {
                      cx: point.x,
                      cy: point.y,
                      r: "8",
                      fill: "transparent"
                    },
                    on: {
                      mouseenter: function($event) {
                        return _vm.showTooltip($event, point, index)
                      },
                      mouseleave: _vm.hideTooltip
                    }
                  })
                ])
              }),
              _vm.tooltipVisible
                ? _c("g", { staticClass: "tooltip-group" }, [
                    _c("rect", {
                      attrs: {
                        x: _vm.tooltipX - 40,
                        y: _vm.tooltipY - 45,
                        width: "80",
                        height: "35",
                        rx: "4",
                        fill: "rgba(0,0,0,0.8)"
                      }
                    }),
                    _c(
                      "text",
                      {
                        attrs: {
                          x: _vm.tooltipX,
                          y: _vm.tooltipY - 25,
                          "text-anchor": "middle",
                          fill: "#fff",
                          "font-size": "11"
                        }
                      },
                      [_vm._v(_vm._s(_vm.tooltipDate))]
                    ),
                    _c(
                      "text",
                      {
                        attrs: {
                          x: _vm.tooltipX,
                          y: _vm.tooltipY - 12,
                          "text-anchor": "middle",
                          fill: "#fff",
                          "font-size": "13",
                          "font-weight": "600"
                        }
                      },
                      [_vm._v(_vm._s(_vm.tooltipValue))]
                    ),
                    _c("polygon", {
                      attrs: {
                        points: `${_vm.tooltipX - 6},${_vm.tooltipY -
                          10} ${_vm.tooltipX + 6},${_vm.tooltipY - 10} ${
                          _vm.tooltipX
                        },${_vm.tooltipY}`,
                        fill: "rgba(0,0,0,0.8)"
                      }
                    })
                  ])
                : _vm._e()
            ],
            2
          )
        ])
      ]),
      _c("div", { staticClass: "top-section" }, [
        _c("div", { staticClass: "section-header" }, [
          _c("span", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.currentTopTitle))
          ])
        ]),
        _c(
          "div",
          { staticClass: "top-list" },
          _vm._l(_vm.currentTopStores, function(item, index) {
            return _c("div", { key: index, staticClass: "top-item" }, [
              _c(
                "span",
                { staticClass: "top-rank", class: _vm.getRankClass(index) },
                [_vm._v(_vm._s(index + 1))]
              ),
              _c("span", { staticClass: "top-name" }, [
                _vm._v(_vm._s(item.name))
              ]),
              _c("span", { staticClass: "top-value" }, [
                _vm._v(_vm._s(_vm.formatTopValue(item)))
              ]),
              item.percent !== undefined
                ? _c("span", { staticClass: "top-percent" }, [
                    _vm._v(_vm._s(item.percent) + "%")
                  ])
                : _vm._e()
            ])
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }